import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e842948e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-personal-data" }
const _hoisted_2 = { class: "flex justify-center" }
const _hoisted_3 = {
  id: "formSignUpPesonalData",
  class: "flex items-center flex-col rounded overflow-hidden"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "titleBold text-left" }, "Dados Pessoais", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " O e-mail informado em \"Dados Pessoais\" será utilizado para realizar o acesso a nossa Plataforma e o e-mail em \"Dados Administrativos\" será utilizado para contato. ", -1))
const _hoisted_6 = { class: "input w-full" }
const _hoisted_7 = { class: "input w-full" }
const _hoisted_8 = { class: "input w-full" }
const _hoisted_9 = { class: "input w-full" }
const _hoisted_10 = { class: "input w-full" }
const _hoisted_11 = { class: "input w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Input, {
            isError: _ctx.isErrorUserName,
            onInput: _ctx.onChangeUserName,
            errorMessage: "Nome de usuário inválido",
            width: "100%",
            label: "Nome",
            pattern: "^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$",
            value: _ctx.userName,
            required: ""
          }, null, 8, ["isError", "onInput", "value"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Input, {
            "v-model": _ctx.email,
            onInput: _ctx.onChangeEmail,
            isError: _ctx.isErrorEmail,
            errorMessage: "E-mail inválido!",
            pattern: "[a-z0-9]+@[a-z]+\\.[a-z]{2,3}",
            type: "email",
            width: "100%",
            label: "Email",
            required: ""
          }, null, 8, ["v-model", "onInput", "isError"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Input, {
            "v-model": _ctx.phone1,
            onInput: _ctx.onChangePhone1,
            isError: _ctx.isErrorPhone1,
            errorMessage: "Telefone inválido",
            width: "100%",
            type: "tel",
            pattern: "(\\(\\d{2}\\)\\s)(\\d{4,5}-\\d{4})",
            label: "Telefone 01",
            mask: "(##) #####-####",
            required: ""
          }, null, 8, ["v-model", "onInput", "isError"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_Input, {
            "v-model": _ctx.phone2,
            onInput: _ctx.onChangePhone2,
            isError: _ctx.isErrorPhone2,
            pattern: "(\\(\\d{2}\\)\\s)(\\d{4,5}-\\d{4})",
            errorMessage: "Telefone inválido",
            width: "100%",
            mask: "(##) #####-####",
            label: "Telefone 02"
          }, null, 8, ["v-model", "onInput", "isError"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_Input, {
            "v-model": _ctx.password,
            onInput: _ctx.onChangePassword,
            isError: _ctx.isErrorPassword,
            errorMessage: "A senha precisa ter pelo menos 8 caracters, 1 letra maíuscula, 1 caracter especial e 1 número",
            type: "password",
            pattern: "^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[$*&@#])[0-9a-zA-Z$*&@#]{8,}$",
            width: "100%",
            label: "Senha",
            required: ""
          }, null, 8, ["v-model", "onInput", "isError"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_Input, {
            id: "confirm-password-2323",
            "v-model": _ctx.confirmPassword,
            onInput: _ctx.onChangeConfirmPassword,
            isError: _ctx.isErrorConfirmPassword,
            type: "password",
            errorMessage: "As senhas não coincidem!",
            pattern: "^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[$*&@#])[0-9a-zA-Z$*&@#]{8,}$",
            width: "100%",
            label: "Confirmação da senha",
            required: ""
          }, null, 8, ["v-model", "onInput", "isError"])
        ])
      ])
    ])
  ]))
}